import { render } from "./CloseCircleOutline.vue?vue&type=template&id=6b0dace3"
import script from "./CloseCircleOutline.vue?vue&type=script&lang=js"
export * from "./CloseCircleOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__